//place here your custom javascript, you're free to create all the js files you need

function handleProductStickyHeader() {
  const stickyHeader = document.querySelector(
    '.product-sticky-header__wrapper'
  );
  const headerWrapper = document.querySelector('.header-wrapper');
  const announcementBarSection = document.querySelector('.announcement-bar-section');
  const footer = document.querySelector('.footer');

  if (!stickyHeader) return;
  const isMobile = window.innerWidth < 750;
  if (isMobile) {
    stickyHeader.classList.add('sticky-bottom');
    const footer = document.querySelector('footer');
    footer.style.paddingBottom = `${stickyHeader.offsetHeight}px`;

    const customBanner = document.querySelector('.custom-banner');
    const stickyHeaderElement = document.querySelector('.product-sticky-header');
    
    if (customBanner && stickyHeaderElement) {
      stickyHeaderElement.appendChild(customBanner);
    }
    
  } else {
    const productInfo = document.getElementsByTagName('product-info')[0];
    if (productInfo) {
      document.addEventListener('scroll', () => {
        const headerHeight = headerWrapper.offsetHeight + 1;
        const announcementBarHeight = announcementBarSection?.offsetHeight || 0;
        const totalHeight = headerHeight + announcementBarHeight;
       
        const productInfoEndPosition =
          productInfo.getBoundingClientRect().bottom + window.scrollY;

        const isBeyondProductInfoEnd =
          window.scrollY + stickyHeader.offsetHeight >= productInfoEndPosition;

        if (isBeyondProductInfoEnd && !isMobile) {
          stickyHeader.classList.add('sticky');
          stickyHeader.style.top = `${totalHeight}px`;
        } else {
          stickyHeader.classList.remove('sticky');
          stickyHeader.style.top = '0';
        }
      });
    }
  }
}

function handleStickyHeader() {
  const stickyHeader = document.querySelector('.sticky-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  const announcementBarSection = document.querySelector('.announcement-bar-section');
  const target = document.querySelector('.main-article');
  //const footer = document.querySelector('.footer');
  if (!headerWrapper || !stickyHeader || !target) return;

  document.addEventListener('scroll', () => {
    const targetPosition = target.getBoundingClientRect().bottom + window.scrollY;
    const headerHeight = headerWrapper.offsetHeight + 1;
    const announcementBarHeight = announcementBarSection?.offsetHeight || 0;
    const totalHeight = headerHeight + announcementBarHeight;
    const header = stickyHeader.getElementsByTagName('header')[0];
    //const footerPosition = footer.getBoundingClientRect().top + window.scrollY;
    //const isOnTopOfFooter = window.scrollY + stickyHeader.offsetHeight >= footerPosition;

    //if (window.scrollY >= targetPosition && !isOnTopOfFooter) {
    if (window.scrollY >= targetPosition) {
      stickyHeader.classList.add('sticky');
      header.style.top = `${totalHeight}px`;
    } else {
      stickyHeader.classList.remove('sticky');
      stickyHeader.style.top = '0';
    }
  });
}

function syncRadioButtons() {
  const allRadios = document.querySelectorAll('input[type="radio"]');
  if (!allRadios.length) return;

  const checkedRadio = Array.from(allRadios).find((radio) => radio.checked);

  if (!allRadios[0].classList.contains('synced')) {
    processStickyHeaderRadioButton(checkedRadio, allRadios);
    addRadioEventListener(allRadios);
  }
}

function processStickyHeaderRadioButton(checkedRadio, allRadios) {
  allRadios.forEach((radio) => {
    radio.classList.add('synced');
    radio.classList.toggle(
      'checked',
      checkedRadio &&
        checkedRadio.dataset.optionValueId === radio.dataset.optionValueId
    );
  });
}

function addRadioEventListener(allRadios) {
  allRadios.forEach((radio) => {
    radio.addEventListener('click', () => {
      if (radio.checked) {
        const valueId = radio.dataset.optionValueId;
        allRadios.forEach((radio) => {
          radio.classList.toggle(
            'checked',
            radio.dataset.optionValueId === valueId
          );
        });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  handleProductStickyHeader();
  syncRadioButtons();
  handleStickyHeader();
  observeStickyBottomVisibility();
});

 function observeStickyBottomVisibility() {
   const stickyBottom = document.querySelector('.sticky-bottom');
   const footer = document.querySelector('.footer');

   if (!stickyBottom || !footer) return;

   const observer = new IntersectionObserver(
     (entries) => {
       entries.forEach((entry) => {
         if (entry.isIntersecting) {
           stickyBottom.style.display = 'none'; 
         } else {
           stickyBottom.style.display = 'block';
         }
       });
     },
     {
       root: null, 
       threshold: 0
     }
   );

   observer.observe(footer);
 }

document.addEventListener('change', function () {
  syncRadioButtons();
});

// FILTER LOGIC
document.addEventListener('DOMContentLoaded', () => {
  const toggleFacetsButton = document.getElementById('toggleFacetsButton');
  const drawerCloseButton = document.querySelector('.mobile-facets__close');
  const applyFiltersButton = document.querySelector('.mobile-facets__apply');
  const activeFacetsButtonWrappers = document.querySelectorAll(
    '.active-facets__button-wrapper'
  );

  toggleInfo();

  toggleFacetsButton?.addEventListener('click', () => {
    toggleFiltersVisibility();
    toggleInfo();
  });

  [drawerCloseButton, applyFiltersButton].forEach((button) =>
    button?.addEventListener('click', toggleInfo)
  );

  activeFacetsButtonWrappers.forEach((wrapper) =>
    wrapper.addEventListener('click', (event) => {
      hideVisibility();
      event.stopPropagation();
    })
  );

  function toggleFiltersVisibility() {
    const facetsWrapper = document.getElementById('main-collection-filters');
    const closeFilter = document.querySelector('.close-filter');
    const openFilter = document.querySelector('.open-filter');
    if (!facetsWrapper || !closeFilter || !openFilter) return;

    facetsWrapper.classList.toggle('active');
    closeFilter.classList.toggle('hidden');
    openFilter.classList.toggle('hidden');

    toggleInfo();
  }

  function toggleInfoVisibility(elements, condition) {
    elements.forEach((element) => element?.classList.toggle('show', condition));
  }

  function toggleInfo() {
    const anyChecked = document.querySelector(
      '#main-collection-filters .facet-checkbox.active'
    );

    toggleInfoVisibility(
      [
        document.querySelector('.center-area'),
        document.querySelector('.clear-results')
      ],
      Boolean(anyChecked)
    );

    toggleInfoVisibility(
      document.querySelectorAll('.active-facets__button-wrapper'),
      Boolean(anyChecked)
    );
  }

  function hideVisibility() {
    toggleInfoVisibility(
      [
        document.querySelector('.center-area'),
        document.querySelector('.clear-results')
      ],
      false
    );

    toggleInfoVisibility(
      document.querySelectorAll('.active-facets__button-wrapper'),
      false
    );
  }
});

// Slider Bar
document.addEventListener('DOMContentLoaded', () => {
  handleSliderBar();

  window.addEventListener('resize', () => {
    handleSliderBar();
  })

  function handleSliderBar() {
    const sliderComponents = document.getElementsByTagName('slider-component'); 
    const scrollThumb = document.querySelector('.scroll-thumb');

    if (Array.from(sliderComponents).length > 0 && scrollThumb) {
      Array.from(sliderComponents).forEach((slider) => {
        if (!slider.classList.contains('slider-enabled')) return;
        const sliderElement = slider.querySelector('.slider');
        const scrollTrack = scrollThumb.parentElement;

        if (sliderElement && scrollTrack) {
          sliderElement.addEventListener('scroll', () => {
            const scrollPercentage = sliderElement.scrollLeft /
              (sliderElement.scrollWidth - sliderElement.clientWidth);

            const maxThumbMovement = scrollTrack.clientWidth - scrollThumb.clientWidth;
            scrollThumb.style.transform = `translateX(${scrollPercentage * maxThumbMovement}px)`;
          });
        }

        const sliderTabletUp = slider.querySelector('.slider--tablet-up');
        const sliderMobile = slider.querySelector('.slider--mobile');
        const scrollBar = slider.querySelector('.scroll-bar');

        if (scrollBar && (sliderMobile || sliderTabletUp)) {
          const isOverflowing = sliderTabletUp.scrollWidth > sliderTabletUp.clientWidth ||
            sliderMobile.scrollWidth > sliderMobile.clientWidth;

          scrollBar.classList.toggle('show', isOverflowing);
        } else {
          scrollBar.classList.remove('show');
        }
      });
    }
  }
});

const sliders = document.querySelectorAll('.slider');
function isDesktop() {
  return window.innerWidth > 768;
}

sliders.forEach((slider) => {
  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;
  slider.addEventListener('mousedown', (e) => {
    if (!isDesktop()) return;
    isDown = true;
    isDragging = false;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', () => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDesktop() || !isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;

    if (Math.abs(walk) > 5) {
      isDragging = true;
    }
    if (isDragging) {
      slider.scrollLeft = scrollLeft - walk;
    }
  });
});

// FAQ Page
document.addEventListener('DOMContentLoaded', () => {
  const faqTocItems = document.querySelectorAll('.faq__toc-item');
  const faqTocItemsArray = Array.from(faqTocItems);
  if (faqTocItemsArray.length == 0) return;
  onCategorySelected(faqTocItemsArray);
  onQuestionSelected(faqTocItems);

  function onCategorySelected(faqTocItemsArray) {
    faqTocItemsArray.forEach((faqTocItem) => {
      faqTocItem.addEventListener('click', () => {
        faqTocItemsArray.forEach((faqTocItem) => {
          faqTocItem.classList.remove('is-active');
        });
        faqTocItem.classList.add('is-active');
      });
    });
  }

  function onQuestionSelected(faqTocItems) {
    const productAccordions = document.querySelectorAll('.product__accordion');
    if (productAccordions.length == 0) return;
    productAccordions.forEach((accordion) => {
      accordion.addEventListener('click', () => {
        let closestH2 = accordion.previousElementSibling;
        while (closestH2 && closestH2.tagName !== 'H2') {
          closestH2 = closestH2.previousElementSibling;
        }
        const closestH2Id = closestH2 ? closestH2.id : null;
        activateCategory(closestH2Id, faqTocItems);
      });
    });
  }

  function activateCategory(id, arrayOfElements) {
    arrayOfElements.forEach((element) => {
      element.classList.remove('is-active');
      if (element.href.includes(`#${id}`)) {
        element.classList.add('is-active');
      }
    });
  }
});

// NEWSLETTER
document.addEventListener('DOMContentLoaded', () => {
  const parentElement = document.querySelector('.footer__newsletter');
  const newsletterCheckboxes = parentElement.querySelectorAll(
    '.newsletter-checkbox'
  );
  const newsletterButton = parentElement.querySelector('.field__button');
  const newsletterInput = parentElement.querySelector('.field__input');

  if (newsletterCheckboxes.length > 0) {
    checkCheckboxes(newsletterCheckboxes);
  }

  if (newsletterButton) {
    onSubmitValidateInput(
      newsletterButton,
      newsletterInput,
      newsletterCheckboxes
    );
  }

  if (newsletterInput) {
    newsletterInput.addEventListener('input', () => {
      newsletterInput.value = newsletterInput.value.toLowerCase();
    });
  }

  function checkCheckboxes(newsletterCheckboxes) {
    const excludedIds = [
      'newsletter-checkbox-profiling-mobile',
      'newsletter-checkbox-profiling-desktop'
    ];
    newsletterCheckboxes.forEach((checkbox) => {
      if (excludedIds.includes(checkbox.id)) {
        // Always keep these checkboxes unchecked
        checkbox.checked = false;
        return;
      }
      checkbox.addEventListener('click', () => {
        if (excludedIds.includes(checkbox.id)) {
          checkbox.checked = false;
          return;
        }
        const isChecked = checkbox.checked;
        newsletterCheckboxes.forEach((cb) => {
          if (!excludedIds.includes(cb.id)) {
            cb.checked = isChecked;
          } else {
            cb.checked = false;
          }
        });
      });
    });
  }

  function onSubmitValidateInput(
    newsletterButton,
    newsletterInput,
    newsletterCheckboxes
  ) {
    newsletterButton.addEventListener('click', function (event) {
      const isCheckboxChecked = Array.from(newsletterCheckboxes).some(
        (checkbox) => checkbox.checked
      );
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (
        !emailPattern.test(newsletterInput.value.trim()) ||
        !isCheckboxChecked
      ) {
        if (!isCheckboxChecked) {
          newsletterCheckboxes.forEach((checkbox) => {
            checkbox.classList.add('newsletter-input-error');
          });
        }
        event.preventDefault();
        newsletterInput.classList.add('newsletter-input-error');
      } else {
        newsletterInput.classList.remove('newsletter-input-error');
      }
    });
  }
  const backButton = document.querySelector('.back-link');
  if (backButton) {
    backButton.addEventListener('click', () => {
      const newsletterText = document.querySelector(
        '.footer-block__description'
      );
      newsletterText.style.display = 'block';

      const newsletterForm = document.querySelector(
        '.newsletter-form__field-wrapper'
      );
      newsletterForm.style.display = 'block';

      const newsletterMessage = document.querySelector(
        '.newsletter-form__message'
      );
      newsletterMessage.style.display = 'none';
    });
  }
});

// Drawer menu - Collections menu columns
document.addEventListener('DOMContentLoaded', () => {
  const announcementBarSection = document.querySelector(
    '.announcement-bar-section'
  );
  const sectionHeader = document.querySelector('.section-header');
  const menuBackButton = document.querySelector('.menu-drawer__close-button');
  const menuTitle = document.querySelector('.grandchild-menu-title');
  const grandChildMenu = document.querySelector('.grandchild-menu');

  if (announcementBarSection && sectionHeader && menuBackButton && menuTitle) {
    const grandChildMenuItems = grandChildMenu.querySelectorAll('li');

    // Use requestAnimationFrame to ensure layout is calculated
    requestAnimationFrame(() => {
      const grandChildMenuItemsCount = grandChildMenuItems.length;
      const menuHeight = grandChildMenuItems[0]?.offsetHeight || 0; // Fallback to 0 if no items
      const grandChildMenuHeight = grandChildMenuItemsCount * menuHeight;


      if (grandChildMenuHeight !== 0) {
        grandChildMenu.style.height = `${grandChildMenuHeight / 2}px`;
      } else {
        grandChildMenu.style.height = `100%`;
      }
    });
  }
});

// Animations
// BANNER
document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelectorAll('.banner');
  if (banners.length === 0) return;

  banners.forEach((banner) => {
    //const img = banner.querySelector('.banner__media img');
    const subtitle = banner.querySelector('.banner__subtitle');
    const heading = banner.querySelector('.banner__heading');
    const text = banner.querySelector('.banner__text');
    const button = banner.querySelector('.banner__buttons');

    const elements = [subtitle, text, button].filter(Boolean);

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            heading.classList.add('reveal');
            observer.unobserve(heading);

            heading.addEventListener('transitionend', () => {
              elements.forEach((el, index) => {
                setTimeout(() => {
                  el.classList.add('reveal');
                }, 500 * index);
              });
            });
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(heading);
  });
});

// Hero Editorial
document.addEventListener('DOMContentLoaded', function () {
  const heroContainer = document.querySelector(
    '.article-template__hero-container'
  );
  const articleHeader = document.querySelector('.article-template header');

  if (heroContainer && articleHeader) {
    setTimeout(() => {
      heroContainer.classList.add('animate-in');
      articleHeader.classList.add('animate-in');
    }, 100);
  }
});

// image animations observer
document.addEventListener('DOMContentLoaded', () => {
  const imageAnimationBlocks = document.querySelectorAll('.image-animation-1, .image-animation-2');
  if (imageAnimationBlocks.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
        observer.unobserve(entry.target);
      }
    });
  });

  imageAnimationBlocks.forEach((block) => {
    observer.observe(block);
  });
});

// Section Animation Stagger
document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.section-stagger-animation'); // Parent container

  blocks.forEach((block) => {
    const images = Array.from(block.querySelectorAll('img, iframe'));
    const texts = Array.from(
      block.querySelectorAll(
        'p, .animatable, .body-1, .card__information, .body-2, .highlight, .h0, .h1, .h2, .h3, .h4, .h5, .subtitle, .subtitle-2, .memo, .handwriting, .voice .text_animation, .image-animation-2, .image-animation-1, .combined-animation, .button'
      )
    );

    // Sort elements based on vertical position (top to bottom)
    const elements = [...images, ...texts];

    // Add the initial hidden class to all elements
    elements.forEach((el) => {
      el.classList.add('hidden-until-visible');
    });

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            if (images.includes(el)) {
              el.classList.remove('hidden-until-visible');
              el.classList.add('stagger-animation');
              observer.unobserve(el); // Stop observing once the animation is triggered

              // Delay the text animations
              setTimeout(() => {
                texts.forEach((textEl) => {
                  textEl.classList.remove('hidden-until-visible');
                  textEl.classList.add('stagger-animation');
                });
              }, 500); // Adjust the delay as needed
            }
          }
        });
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );
    if (images.length === 0) {
      // If there are no images, process the texts directly
      texts.forEach((textEl) => {
        textEl.classList.remove('hidden-until-visible');
        textEl.classList.add('stagger-animation');
      });
    } else {
      // Observe each element
      elements.forEach((el) => {
        observer.observe(el);
      });
    }
  });
});

//Observing the text elements
document.addEventListener('DOMContentLoaded', () => {
  const textAnimationElements = document.querySelectorAll('.text_animation');

  if (textAnimationElements.length > 0) {
    textAnimationElements.forEach((element) => {
      element.classList.add('hidden-until-visible');
    });

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('hidden-until-visible');
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    });

    textAnimationElements.forEach((element) => {
      observer.observe(element);
    });
  }
});

// DRAGGABLE FILTER LOGIC
document.addEventListener('DOMContentLoaded', function () {
  const sliderContainers = document.querySelectorAll('.slider-container');
  if (sliderContainers.length === 0) return;

  // Initialize the component
  sliderContainers.forEach((sliderContainer) => {
    initSlider(sliderContainer);
  });

  function initSlider(sliderContainer) {
    let values, handle, sliderTrack, checkboxes;
    const positions = [0, 50, 100]; // Percent positions
    let isDragging = false;
    let sliderWidth;
    let startX;
    let initialLeft;
    let manualMove = false;
    values = sliderContainer.querySelectorAll('.slider-value');
    handle = sliderContainer.querySelector('.slider-handle');
    handle.setAttribute('handle-bound', true);
    sliderTrack = sliderContainer.querySelector('.slider-track');
    checkboxes = sliderContainer.querySelectorAll('input[type="checkbox"]');
    sliderWidth = sliderTrack.offsetWidth;

    values.forEach((value, index) => {
      value.addEventListener('click', () => {
        // Check if corresponding checkbox is disabled
        if (checkboxes[index] && checkboxes[index].disabled) {
          return; // Do nothing if disabled
        }
        updateSlider(index);
      });
    });

    function startDrag(e) {
      isDragging = true;
      manualMove = true;
      handle.style.transition = 'none';
      startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      initialLeft = parseFloat(handle.style.left);
    }

    function moveDrag(e) {
      if (!isDragging) return;

      const currentX =
        e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      let offsetX = currentX - startX;
      let percent = initialLeft + (offsetX / sliderWidth) * 100;

      if (percent < 0) percent = 0;
      if (percent > 100) percent = 100;

      handle.style.left = percent + '%';
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;

      let currentLeft = parseFloat(handle.style.left);
      let closestIndex = positions.reduce(
        (prev, curr, i) =>
          Math.abs(curr - currentLeft) < Math.abs(positions[prev] - currentLeft)
            ? i
            : prev,
        0
      );

      // If the closest position has a disabled checkbox, fall back to current active
      let validIndex = closestIndex;
      if (checkboxes[closestIndex] && checkboxes[closestIndex].disabled) {
        // Find the currently active checkbox
        const activeIndex = Array.from(checkboxes).findIndex(
          (checkbox) => checkbox.checked
        );
        validIndex = activeIndex !== -1 ? activeIndex : 1; // Default to center if no active found
        manualMove = false;
      }

      updateSlider(validIndex);
      manualMove = false;
    }

    function updateSlider(index, animate = true) {
      handle.style.left = positions[index] + '%';
      if (!animate) {
        handle.style.transition = 'none';
        // Force a reflow to ensure the position is set immediately
        handle.offsetHeight;
        handle.style.transition = '';
      } else {
        handle.style.transition = 'left 0.2s ease';
      }

      values.forEach((value, i) =>
        value.classList.toggle('active', i === index)
      );
      checkboxes.forEach((checkbox, i) => {
        checkbox.checked = i === index;
        // Only trigger click if it's a manual move and checkbox is not disabled
        if (i === index && manualMove && !checkbox.disabled) {
          checkbox.click();
        }
      });
    }


    handle.addEventListener('mousedown', startDrag);
    handle.addEventListener('touchstart', startDrag);

    document.addEventListener('mousemove', moveDrag);
    document.addEventListener('touchmove', moveDrag);

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);

    // Listen for checkbox changes to update handle position
    checkboxes.forEach((checkbox, index) => {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          // Update handle position to match the checked checkbox
          manualMove = false; // Don't trigger another click
          updateSlider(index, true);
        }
      });
    });

    // Set initial position based on checked checkbox or center if none are checked
    const checkedIndex = Array.from(checkboxes).findIndex(
      (checkbox) => checkbox.checked
    );
    updateSlider(checkedIndex !== -1 ? checkedIndex : 1, false);
  }

  const mobileFacets = document.querySelector('.mobile-facets');
  if (mobileFacets) {
    const mobileFacetsObserver = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const newSliders = mutation.addedNodes;
          newSliders.forEach((node) => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.classList.contains('slider-container') &&
              !node.hasAttribute('handle-bound')
            ) {
              node.setAttribute('handle-bound', 'true');
              initSlider(node);
            }
          });
        }
      });
    });

    mobileFacetsObserver.observe(mobileFacets, {
      childList: true,
      subtree: true
    });
  }
  const facets = document.querySelector('.facets-container');
  if (facets) {
    const facetsObserver = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const newSliders = mutation.addedNodes;
          newSliders.forEach((node) => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.classList.contains('facets__summary')
            ) {
              const parentNode = node.closest('.slider-container'); 
              if (!parentNode || parentNode.hasAttribute('handle-bound')) return;
              node.setAttribute('handle-bound', 'true');
              initSlider(parentNode);
            }
          });
        }
      });
    });

    facetsObserver.observe(facets, {
      childList: true,
      subtree: true
    });
  }

});

// Cart Validation Logic

document.addEventListener('DOMContentLoaded', () => {
  const cartValidationModule = createCartValidationModule();
  cartValidationModule.observeForCheckoutButtonCreation();
});

function createCartValidationModule() {
  function observeForCheckoutButtonCreation() {
    const elements = document.querySelectorAll(
      '.drawer__footer button[type="submit"]'
    );

    Array.from(elements).forEach((element) => {
      if (!element.hasAttribute('data-bound')) {
        element.setAttribute('data-bound', 'true');
        bindGoToCheckout(element);
      }
    });

    const observer = new MutationObserver((mutationsList) => {

      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const elements = document.querySelectorAll(
            '.drawer__footer button[type="submit"]'
          );
          Array.from(elements).forEach((element) => {
            if (!element.hasAttribute('data-bound')) {
              element.setAttribute('data-bound', 'true');

              bindGoToCheckout(element);
            }
          });
        }
      }
    });

    const targetNode = document.getElementsByTagName('cart-drawer');

    if (targetNode) {
      observer.observe(Array.from(targetNode)[0], {
        childList: true,
        subtree: true
      });
    }

    const cartPage = document.getElementById('main-cart-footer');
    const submitButton = cartPage?.querySelector('button[type="submit"]');
    if (cartPage) bindGoToCheckout(submitButton);
  }

  function bindGoToCheckout(element) {

    element.addEventListener('click', async (e) => {
      e.preventDefault();
      await checkoutValidation(e);
    });
  }

  async function checkoutValidation(event) {
    event.preventDefault();
    const button = event.target;
    button.disabled = true;

    try {
      const cart = await fetchCart();      
      await initCartValidation(cart);
      window.location.href = `${Shopify.routes.root}checkout`;
    } catch (error) {
      console.error('Cart validation failed:', error);
    } finally {
      button.disabled = false;
    }
  }

  async function fetchCart() {
    const response = await fetch(`${Shopify.routes.root}cart.js`, {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }

    return response.json();
  }

  async function initCartValidation(cart) {
    const limitSampleKit = window.products.limit_sample_kit;
    const sampleKitHandle = window.products.sample_kit_handle;
    const limitDiscoverySet = window.products.limit_discovery_set;
    const discoverySetHanlde = window.products.discovery_set_handle;

    const cartItemsByTag = document.querySelectorAll('[data-tags*="customizable"]');
    const limitedIds = Array.from(cartItemsByTag).map((item) => item.dataset.id).join(',');
    
    try {
      const itemsToRemove = [];
      const cartAggregated = aggregateProductIds(cart.items);
      cart.items.forEach((item) => {
        if (limitedIds.includes(item.id.toString())) {
          switch (item.handle) {
            case sampleKitHandle:
              if (
                item.quantity > limitSampleKit ||
                cartAggregated[item.id] > limitSampleKit
              ) {
                cartAggregated[item.id] = cartAggregated[item.id] - 1;
                itemsToRemove.push(item);
              }
              break;
            case discoverySetHanlde:
              if (item.quantity > limitDiscoverySet) {
                itemsToRemove.push(item);
              }
              break;

            default:
              break;
          }
        }
      });
      if (itemsToRemove.length != 0) {
        await removeCartItems(itemsToRemove);
      }
    } catch (error) {
      throw new Error('Cart validation failed', error);
    }
  }

  function aggregateProductIds(cartItems) {
    const productCounts = {};

    cartItems.forEach((item) => {
      const productId = item.id;

      if (productCounts[productId]) {
        productCounts[productId] += 1; // Increment count if the ID already exists
      } else {
        productCounts[productId] = 1; // Initialize count if the ID is new
      }
    });

    return productCounts;
  }

  async function removeCartItems(itemsToRemove) {
    const itemKeys = itemsToRemove.map((item) => item.key);
    const updates = itemKeys.reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});

    return new Promise(async (resolve) => {
      fetch(`${Shopify.routes.root}cart` + '/update.js', {
        body: JSON.stringify({ updates }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then((response) => {
          response.json().then(function (content) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // removeDeletedItems(itemsToRemove);
            resolve(true);
          });
        })
        .catch((error) => {
          throw new Error('Failed to remove cart items', error);
        });
    });
  }

  function removeDeletedItems(itemsToRemove) {
    itemsToRemove.forEach((item) => {
      const cartItem = document.querySelectorAll(
        `[data-variant-key="${item.key}"]`
      );
      if (cartItem.length > 0) cartItem.forEach((item) => item.remove());
    });
  }

  return {
    observeForCheckoutButtonCreation
  };
}

// Cart - show custom banners logic
document.addEventListener('DOMContentLoaded', () => {
  const cartPage = document.querySelector('.cart-items-section');
  const cartValueContainer = document.querySelector('.js-contents');
  if (cartPage && cartValueContainer) {
    const cartValue = retrieveCartValue();
    if (!cartValue) return;

    const cartCustomBanners = document.querySelectorAll('.custom-banner');
    Array.from(cartCustomBanners).forEach((banner) => {
      showBanner(banner, cartValue);
    });

    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const cartValue = retrieveCartValue();
          if (!cartValue) return;
          Array.from(cartCustomBanners).forEach((banner) => {
            showBanner(banner, cartValue);
          });
        }
      }
    });
    observer.observe(cartPage, { childList: true, subtree: true });
  }

  function showBanner(banner, cartValue) {
    const showAtAmount = banner.getAttribute('data_show_at_amount');
    if (showAtAmount == 'false') return;

    const bannerMinValue =
      Number(banner.getAttribute('data_min_value')) || null;
    const bannerMaxValue =
      Number(banner.getAttribute('data_max_value')) || null;
    const bannerBelowValue =
      Number(banner.getAttribute('data_below_value')) || null;
    const bannerAboveValue =
      Number(banner.getAttribute('data_above_value')) || null;

    const bannerContainer = banner.closest('.custom-banner-wrapper');
    if (!bannerContainer) return;

    const isVisible =
      (bannerMinValue !== null &&
        cartValue > bannerMinValue &&
        cartValue < bannerMaxValue) ||
      (bannerBelowValue !== null && cartValue < bannerBelowValue) ||
      (bannerAboveValue !== null && cartValue > bannerAboveValue);

    bannerContainer.style.display = isVisible ? 'block' : 'none';
    bannerContainer.style.visibility = isVisible ? 'visible' : 'hidden';
  }

  function retrieveCartValue() {
    const cartValueElement = document.querySelector(
      '.cart__footer .totals__total-value'
    );
    const cartValueText = cartValueElement?.textContent.trim();
    if (!cartValueText) return null;
    const cartValueNumber =
      parseFloat(cartValueText.replace(/[^\d,]/g, '').replace(',', '.')) ||
      null;
    return cartValueNumber;
  }
});


// handle product page variant images
  document.addEventListener('DOMContentLoaded', () => {
    showCurrentVariantImages();
      
    document.addEventListener('change', () => {
      showCurrentVariantImages();
    });
  })


function showCurrentVariantImages(){
 const variantThumbnails = document.querySelectorAll(
   '.product-form__option-container input[type="radio"]'
 );
 if (variantThumbnails.length === 0) return;

 const selectedVariantIndex = Array.from(variantThumbnails).findIndex(
   (thumbnail) => thumbnail.classList.contains('checked')
 );

 const currentVariant =
   variantThumbnails[selectedVariantIndex].getAttribute('variant-id');

 const galleryImages = document.querySelectorAll('.product__media-item');
 const collageImages = document.querySelectorAll('.collage-from-variant-image');

 const allImages = [...galleryImages, ...collageImages];

 allImages.forEach((image) => {
   const imageVariantId = image.getAttribute('data-variant-id');
   if (imageVariantId === currentVariant) {
     image.removeAttribute('hidden');
   } else {
     image.setAttribute('hidden', true);
   }
 });
}

// handle height of banner in home page
 document.addEventListener('DOMContentLoaded', function () {
  const mainHp = document.querySelector('main.homepage');

  if (!mainHp) return;
  
  const announcementBar = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.header-wrapper');

  function calculateBannerHeight() {
    const headerHeight = header ? header.offsetHeight : 0;
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    return window.innerHeight - headerHeight - announcementBarHeight;
  }

  function updateBannerHeight() {
    const bannerHeight = calculateBannerHeight();
    document.documentElement.style.setProperty('--banner-height', `${bannerHeight}px`);

  }

  updateBannerHeight();
  window.addEventListener('resize', () => updateBannerHeight());
});

// Scroll to top if capthca challenge
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.search.includes('?form_key')) {
    const observer = new MutationObserver((mutations, obs) => {
      if (
        document.querySelector(
          '#h-captcha, .g-recaptcha, #g-recaptcha, .shopify-challenge__container'
        )
      ) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.search.includes('?customer_posted')) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});
